/* Open Field Look v1.1 · motion
   One deferred file. No dependencies. Respects prefers-reduced-motion.
   Hooks (all optional, all data attributes):
   data-of-reveal  data-of-lines  data-of-stagger  data-of-count  data-of-magnet
   .of-hero (intro + pointer depth)  .of-scrub  .of-track  [data-of-acc]  [data-of-modes]
   .of-nav  .of-progress  .of-sticky */
(function () {
  "use strict";
  var doc = document.documentElement;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine = window.matchMedia("(pointer: fine)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  doc.classList.add("of-js");
  doc.classList.add("of-ready");

  /* ---------- reveal on scroll ---------- */
  $$("[data-of-lines]").forEach(function (el) {
    $$(".of-line > span", el).forEach(function (s, i) { s.style.setProperty("--of-i", i); });
  });
  $$("[data-of-stagger]").forEach(function (el) {
    Array.prototype.forEach.call(el.children, function (c, i) { c.style.setProperty("--of-i", i); });
  });
  var revealables = $$("[data-of-reveal],[data-of-lines],[data-of-stagger],[data-of-count]");
  function showAll() { revealables.forEach(function (el) { el.classList.add("is-in", "is-done"); count(el, true); }); }
  if (reduce || !("IntersectionObserver" in window)) { showAll(); }
  else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add("is-in");
        if (e.target.hasAttribute("data-of-stagger")) { var t = e.target; setTimeout(function () { t.classList.add("is-done"); }, 1600); }
        count(e.target, false);
        io.unobserve(e.target);
      });
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.12 });
    revealables.forEach(function (el) { io.observe(el); });
  }

  /* ---------- counters ---------- */
  function count(el, instant) {
    if (!el.hasAttribute("data-of-count") || el.dataset.ofDone) return;
    el.dataset.ofDone = "1";
    var end = parseFloat(el.getAttribute("data-of-count")) || 0;
    var out = $(".of-num", el) || el;
    if (instant) { out.textContent = end; return; }
    var t0 = null, dur = 1400;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var v = 1 - Math.pow(1 - p, 4);
      out.textContent = Math.round(end * v);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- hero intro + pointer depth ---------- */
  var hero = $(".of-hero");
  if (hero) {
    var go = function () { hero.classList.add("is-loaded"); };
    var img = $(".of-subject img", hero);
    if (reduce) go();
    else if (img && !img.complete) { img.addEventListener("load", go, { once: true }); setTimeout(go, 1200); }
    else setTimeout(go, 60);

    if (fine && !reduce) {
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = 0, live = true;
      hero.addEventListener("pointermove", function (e) {
        var r = hero.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width * 2 - 1;
        ty = (e.clientY - r.top) / r.height * 2 - 1;
        if (!raf) raf = requestAnimationFrame(tick);
      });
      hero.addEventListener("pointerleave", function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(tick); });
      var tick = function () {
        cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
        hero.style.setProperty("--of-mx", cx.toFixed(4));
        hero.style.setProperty("--of-my", cy.toFixed(4));
        raf = (live && (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001)) ? requestAnimationFrame(tick) : 0;
      };
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (e) { live = e[0].isIntersecting; }).observe(hero);
      }
    }
  }

  /* ---------- magnetic buttons ---------- */
  if (fine && !reduce) {
    $$("[data-of-magnet]").forEach(function (b) {
      b.addEventListener("pointermove", function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = "translate(" + (x * 10).toFixed(2) + "px," + (y * 8).toFixed(2) + "px)";
      });
      b.addEventListener("pointerleave", function () { b.style.transform = ""; });
    });
  }

  /* ---------- scrubbed statement ---------- */
  var scrubs = $$(".of-scrub");
  scrubs.forEach(function (el) {
    var html = "";
    Array.prototype.forEach.call(el.childNodes, function (n) {
      var hot = n.nodeType === 1 && n.tagName === "EM";
      (n.textContent || "").split(/(\s+)/).forEach(function (w) {
        if (!w) return;
        html += /^\s+$/.test(w) ? w : '<span class="w' + (hot ? " hot" : "") + '">' + w + "</span>";
      });
    });
    el.innerHTML = html;
    el._w = $$(".w", el);
  });

  /* ---------- scroll-driven bits (one rAF-throttled handler) ---------- */
  var nav = $(".of-nav"), bar = $(".of-progress"), sticky = $(".of-sticky");
  var tracks = $$(".of-track");
  var ctaEnd = $("[data-of-sticky-stop]");
  var lastY = window.scrollY, ticking = false;
  function onScroll() {
    var y = window.scrollY, vh = window.innerHeight;
    var max = document.documentElement.scrollHeight - vh;
    if (bar) bar.style.setProperty("--of-p", max > 0 ? (y / max).toFixed(4) : 0);
    if (nav) {
      nav.classList.toggle("is-scrolled", y > 20);
      nav.classList.toggle("is-hidden", y > 480 && y > lastY + 2);
      if (y < lastY - 2) nav.classList.remove("is-hidden");
    }
    scrubs.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      p = reduce ? 1 : Math.max(0, Math.min(1, p));
      var n = Math.round(p * el._w.length);
      el._w.forEach(function (w, i) { w.classList.toggle("on", i < n); });
    });
    tracks.forEach(function (t) {
      var r = t.getBoundingClientRect();
      var mob = window.innerWidth <= 860;
      var p = mob ? (vh * 0.6 - r.top) / r.height : (vh * 0.75 - r.top) / (vh * 0.5);
      p = reduce ? 1 : Math.max(0, Math.min(1, p));
      t.style.setProperty("--of-fill", p.toFixed(3));
      var ph = $$(".of-phase", t);
      ph.forEach(function (el, i) { el.classList.toggle("is-lit", p >= (mob ? i / ph.length + 0.02 : i / (ph.length - 1) - 0.001)); });
    });
    if (sticky) {
      var past = hero ? hero.getBoundingClientRect().bottom < 0 : y > 600;
      var atEnd = ctaEnd ? ctaEnd.getBoundingClientRect().top < vh : false;
      sticky.classList.toggle("is-on", past && !atEnd);
    }
    lastY = y; ticking = false;
  }
  window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener("resize", onScroll);
  onScroll();

  /* active nav link */
  var links = $$(".of-nav__links a[href^='#']");
  if (links.length && "IntersectionObserver" in window) {
    var spy = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.classList.toggle("is-active", a.getAttribute("href") === "#" + e.target.id); });
      });
    }, { rootMargin: "-45% 0px -50% 0px" });
    links.forEach(function (a) { var s = $(a.getAttribute("href")); if (s) spy.observe(s); });
  }

  /* ---------- accordion (one open at a time) ---------- */
  $$("[data-of-acc]").forEach(function (list) {
    var items = $$(".of-item", list);
    function set(item, open) {
      item.classList.toggle("is-open", open);
      var b = $(".of-item__btn", item), p = $(".of-item__panel", item);
      b.setAttribute("aria-expanded", open ? "true" : "false");
      p.setAttribute("aria-hidden", open ? "false" : "true");
      if ("inert" in p) p.inert = !open;
    }
    items.forEach(function (item) {
      set(item, item.classList.contains("is-open"));
      $(".of-item__btn", item).addEventListener("click", function () {
        var open = !item.classList.contains("is-open");
        items.forEach(function (o) { set(o, false); });
        set(item, open);
      });
    });
  });

  /* ---------- mode switch ---------- */
  $$("[data-of-modes]").forEach(function (box) {
    var tabs = $$("[role=tab]", box), panels = $$("[role=tabpanel]", box), days = $$(".of-day", box);
    var mid = $(".of-week__mid b", box), midL = $(".of-week__mid span", box);
    function pick(i, focus) {
      var t = tabs[i];
      box.style.setProperty("--of-mode", t.getAttribute("data-color"));
      box.style.setProperty("--of-k", i);
      tabs.forEach(function (o, j) { o.setAttribute("aria-selected", j === i ? "true" : "false"); o.tabIndex = j === i ? 0 : -1; });
      panels.forEach(function (p, j) {
        p.hidden = j !== i;
        if (j === i && !reduce) { p.classList.remove("is-swap"); void p.offsetWidth; p.classList.add("is-swap"); }
      });
      var pat = (t.getAttribute("data-days") || "").split(",");
      days.forEach(function (d, j) {
        d.classList.toggle("is-on", pat[j] === "1");
        d.classList.toggle("is-half", pat[j] === "h");
      });
      if (mid) mid.textContent = t.getAttribute("data-big") || "";
      if (midL) midL.textContent = t.getAttribute("data-big-label") || "";
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () { pick(i); });
      t.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") { e.preventDefault(); pick((i + 1) % tabs.length, true); }
        if (e.key === "ArrowLeft") { e.preventDefault(); pick((i + tabs.length - 1) % tabs.length, true); }
      });
    });
    var start = tabs.findIndex ? tabs.findIndex(function (t) { return t.getAttribute("aria-selected") === "true"; }) : 0;
    pick(start < 0 ? 0 : start);
  });
})();
